import {
	ReminderEntityTypeEnum,
	type TimelineItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { z } from "zod";

// Mirrors TimelineReminderDataDTO. `data` is a union of six DTOs without a
// discriminator of its own, so the shape is still checked at runtime.
const reminderDataSchema = z.object({
	reminderId: z.number().nullish(),
	// entityType stays required — without it we cannot build the route
	// (current behavior: skip navigation).
	entityType: z.nativeEnum(ReminderEntityTypeEnum),
	entityId: z.number().transform(String).nullish(),
});

export type ReminderData = z.infer<typeof reminderDataSchema>;

export const parseReminderData = (
	data: TimelineItemResponseDTO["data"],
): ReminderData | null => {
	const result = reminderDataSchema.safeParse(data);
	return result.success ? result.data : null;
};
